import { LayoutNesting } from "#modules/layouts/infra/LayoutNesting.dto";
import { LayoutComputingForm } from "#modules/layouts/view/LayoutComputingForm";
import { useLayout } from "#modules/layouts/view/useLayout";
import { Modal } from "#shared/view/components/Modal";

import { QuoteRequestLineDto } from "../infra/fetchQuoteRequestLine.api";

type Props = {
  show: boolean;
  onClose: () => void;
  quoteRequestLine: QuoteRequestLineDto;
  handleSetCurrentLayoutNesting: (layoutNesting: LayoutNesting) => void;
  currentLayoutNesting: LayoutNesting | null;
  hasChildren: boolean;
  isChild: boolean;
};

export default function LayoutModal({
  show,
  onClose,
  quoteRequestLine,
  handleSetCurrentLayoutNesting,
  currentLayoutNesting,
  hasChildren,
  isChild,
}: Props) {
  const layoutId = quoteRequestLine.layoutId;

  const { layout } = useLayout(layoutId || "");

  if (!layoutId || !layout) {
    return null;
  }

  return (
    <Modal opened={show} onClose={onClose} size="xl">
      <LayoutComputingForm
        quoteRequestLine={quoteRequestLine}
        onSave={onClose}
        layout={layout}
        currentLayoutNesting={currentLayoutNesting}
        handleSetCurrentLayoutNesting={handleSetCurrentLayoutNesting}
        hasChildren={hasChildren}
        isChild={isChild}
      />
    </Modal>
  );
}
